import React from 'react';
import EntityForm from './EntityForm';

const TALLY_NAME_SUGGESTIONS = [
    'Master Carton - 5 Ply', 'Semi-Auto Master Carton', 'Top Bottom', 'Box', 'Tag', 'Sticker',
    'Inner Box Carton - 5 Ply', 'Stiffiner 3 Ply', 'Back Board 3 Ply', 'Poly Bag (Finished Good)',
];

function ManageItemForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Item"
            heading="Add New Item"
            idKey="ItemID"
            insertUrl="insert_manage_item"
            updateUrl="update_manage_item"
            deleteUrl="delete_manage_item"
            fields={[
                { name: 'name', label: 'Name', entryKey: 'Name', required: true },
                { name: 'category', label: 'Category', entryKey: 'Category', type: 'select', defaultValue: 'Carton', options: ['Carton', 'Divider', 'Top Bottom', 'Stiffener', 'Poly', 'Gum Tape', 'ACS Carton'] },
                { name: 'heightorthickness', label: 'Height or Thickness', entryKey: 'HeightOrThickness', type: 'select', defaultValue: 'All Height/Thickness', options: ['All Height/Thickness', 'Height', 'Thickness', 'Height+Thickness', 'No Height/Thickness'] },
                { name: 'tallyname', label: 'Tally Name', entryKey: 'TallyName', placeholder: 'Leave blank to auto-assign from category', suggestions: TALLY_NAME_SUGGESTIONS, help: 'Stock item in Tally used when this item is posted. Blank = closest match for the category.' },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageItemForm;
